// ── 공지사항 관리 헬퍼 ──────────────────────────────────────
// 공지 카테고리, 배지, 필터 등 공통 상수/함수 관리

export const NOTICE_CATEGORIES = [
  { value: "patch",  label: "🔧 패치노트", color: "#534AB7", bg: "#534AB722" },
  { value: "notice", label: "📢 공지",     color: "#e05555", bg: "#A32D2D22" },
  { value: "event",  label: "🎉 이벤트",   color: "#E4A800", bg: "#E4A80022" },
];

export function getCategoryInfo(category) {
  return NOTICE_CATEGORIES.find(c => c.value === category) || NOTICE_CATEGORIES[1];
}

export function getCategoryLabel(category) {
  return getCategoryInfo(category).label;
}

export function getCategoryColor(category) {
  return getCategoryInfo(category).color;
}

export function getCategoryBg(category) {
  return getCategoryInfo(category).bg;
}

// 제목에서 마크다운 헤더/이모지 제거
export function cleanTitle(title = "") {
  return title.replace(/^#+\s*/g, "").replace(/^[📢🔧🎉]\s*/g, "").trim();
}

// 공지 목록 정렬 (pinned 먼저, 이후 최신순)
export function sortNotices(notices) {
  return [...notices].sort((a, b) => {
    if (a.pinned && !b.pinned) return -1;
    if (!a.pinned && b.pinned) return 1;
    const ta = a.createdAt?.seconds || 0;
    const tb = b.createdAt?.seconds || 0;
    return tb - ta;
  });
}
